import imgOffer from "../Images/selectivefocus.webp"


const heroDetails = {
    title : "Hire Dedicated",
    title_s:"Developers",
    description : "Are you searching for a dedicated software engineer to develop a digital project? Or, looking to hire a dedicated development team for your projects? Serviots offers offshore dedicated developers for hire who are trained to deliver mission-critical projects on a deadline.",
    btnTitle: "Schedule a Demo call",
    details: [
        {
            title: "Project Delivered on Time",
            desc : "96%"
        },
        {
            title: "In-House Team",
            desc : "57"
        },   {
            title: "Expert Support",
            desc : "24/7"
        },
    ],
    link:"https://wa.me/919265435410?text=Hi%20there!"

  }

  const priceDetails = [
    {
        title:"Dedicated Team Model",
        price:"$80",
        desc :"Ideal for: Ongoing and Long term projects",
        lists :  [
            "Dedicated SPOC",
            "Dedicated Team",
            "Dedicated Developers",
            "Flexibility Scale Up/Down Team",
            "Complete Control Over Priority and Timeline"
        ],
        isRecommended : false

    },
    {
        title:"Time & Material",
        price:"$80",
        desc :"Ideal for: Projects with evolving requirements",
        lists :[
            "Dedicated SPOC",
            "Agile development",
            "Hourly based pricing",
            "Dedicated resource allocation",
            "Flexibility to change scope, timeline",
            "Fixed Costs"
        ],
        isRecommended : true
    },
    {
        title:"Fixed Costs",
        price:"$80",
        desc :"Ideal for: Projects with clear goals & defined scope",
        lists :[
            "Agile Price",
            "Fixed Timeline",
            "Dedicated SPOC",
            "Dedicated Team",
            "Milestone Based Payment",
            "Dedicated resource allocation"
        ],
        isRecommended : false
    },
]


const hireDetailsOne = {
    title:"HIRE US NOW",
    title_p: "Do you want to Hire Dedicated Developers/ Teams for your Projects?",
    desc:"We provide top-rated software developers for hire at cost-effective rates. Hire developers of your choice using flexible hiring models.",
    btnTitle:"Hire Talents Now",
    link:"/schedule-interview"
}

const hireDetails = {
    title:"HIRE US NOW",
    title_p: "Get Started with Dedicated Development Team",
    desc:"Connect with the top-rated development team or hire individual developers to kick-start your project.",
    btnTitle:"Hire Us Now"
}

const tabData = [
    { label: "Most Hired", content: "We are a leading software development company offering dedicated software developers for hire. We have a team with 2 to 10+ years of experience. Hire dedicated developers with expertise in creating high-quality and scalable applications, irrespective of your business challenges.", lists:["Hire React.JS Developers","Hire Full-Stack Developers","Hire AI Engineers","Hire UI/UX Designers"] },
    { label: "Back-end", content: "Hire dedicated backend developers as part of your existing team or build a new development team from scratch. They are experts in creating core functionalities, managing databases, handling server-side logic, and delivering robust and efficient user experience.",lists:["Hire Node.js Developers","Hire MongoDB Developers","Hire Laravel Developers","Hire Django Developers"]  },
    { label: "Front-end", content: "Hire dedicated front-end developers with expertise in creating visually appealing and interactive user interfaces and delivering fast and scalable websites or applications." ,lists:["Hire React.JS Developers","Hire JavaScript Developers","Hire Angular Developers","Hire React Native Developers"]},
    { label: "Mobile", content: "We have skilled and experienced mobile developers who help you build mobile applications on Native (Android, iOS), hybrid, and cross-platform frameworks. Hire dedicated mobile application developers and create the app you need for your project.", lists:["Hire Android Developers","Hire iOS Developers","Hire Cross-platform App Developers","Hire Hybrid Developers"] },
    { label: "Web Developers", content: "Hire web developers for your web development projects. We have an expert team with expertise in various technologies and frameworks.", lists:["Hire WordPress Developers","Hire Shopify Developers","Hire Full-stack Developers"] },
    { label: "Tech-Specific", content: "Hire specialized dedicated developers for specific projects. Whether you are looking for dedicated AI engineers, Data Scientists, Next JS developers, Gen AI developers, or Data Analyst developers, we easily deliver your needs.",lists:["Hire AI/ML Developers","Hire IoT Developers","Hire DevOps Experts"] },
  ];

const topReasons =  [
    "100% In-house Team",
    "Time Zone Aligned",
    "Flexible Engagement Models",
    "Real-Time Progress Monitoring",
    "Cost-Effective Development",
    "Commitment to On-time Delivery",
    "90% Talent Retention Ratio",
    "Global Management Standards",
    "Security and Compliances",
    "Agile/Scrum Development",
    "Fully Equipped Infrastructure"
  ];

    const weOffer = {
      title_s :"What we Do",
      title:"What We Offer to ",
      title_h:"Hire",
      description:"Tech It Easy provides a wide range of dedicated developers, designers, project managers, Quality Analysts, UI/UX Designers, and more to hire on ad hoc projects",
       lists: [
        { title: "Jr. Developers (1 to 2+ Exp)" },
        { title: "Sr. Developers (2 to 10+ Exp)" },
        { title: "UI/UX Designers (1 to 10+ Exp)" },
        { title: "Team Leader" },
        { title: "Quality Analyst (QA)" },
        { title: "Chief Project Manager" },
        { title: "Chief Technological Officer (CTO)" }
      ],
            img:imgOffer
    };
  
  
export {heroDetails,priceDetails,hireDetails,hireDetailsOne,tabData,topReasons,weOffer}